import { render, staticRenderFns } from "./OrganizationSchoolsGraphs.vue?vue&type=template&id=f0b1e988&scoped=true&"
import script from "./OrganizationSchoolsGraphs.vue?vue&type=script&lang=js&"
export * from "./OrganizationSchoolsGraphs.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSchoolsGraphs.vue?vue&type=style&index=0&id=f0b1e988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b1e988",
  null
  
)

export default component.exports